<script setup>
import {onMounted} from "vue";
import {useRoute} from "vue-router";
import {Api} from "@/service/api";

const route = useRoute()

onMounted(async() => {
    try {
        const code = route.query.code
        if (code) {
            await Api.attachVkAcc(code)
            // Закрываем текущее окно
            window.close()
        }
    } catch (error) {
        console.error('Ошибка при привязке VK аккаунта:', error)
    }
})

</script>

<template>
    <div>
    </div>
</template>

<style scoped>

</style>